import React from "react";
import useReactApexChart from "../../hook/useReactApexChart";
import ReactApexChart from "react-apexcharts";
const SupportTracket = ({support}) => {
  let { donutChartOptionsTwo } = useReactApexChart();
  
  let trimmedSupport = support.slice(1)
  
  
  return (
    <div className="">
      <div className="card h-100 radius-8 border-0 overflow-hidden">
        <div className="card-body p-24">
          <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between">
            <h6 className="mb-2 fw-bold text-lg">Support Overview</h6>
          </div>
          <div className="d-flex flex-wrap align-items-center mt-3">
            <ul className="flex-shrink-0 row">
              <li className="d-flex align-items-center gap-2 mb-28">
                <span className="w-12-px h-12-px rounded-circle bg-success-main" />
                <span className="text-secondary-light text-sm fw-medium">
                  {`Total :${support[0]}`}
                </span>
              </li>
              <li className="d-flex align-items-center gap-2 mb-28">
                <span className="w-12-px h-12-px rounded-circle bg-warning-main" />
                <span className="text-secondary-light text-sm fw-medium">
                  {`Open :${support[1]}`}
                </span>
              </li>
              <li className="d-flex align-items-center gap-2">
                <span className="w-12-px h-12-px rounded-circle bg-primary-600" />
                <span className="text-secondary-light text-sm fw-medium">
                  {`Closed : ${support[2]}`}
                </span>
              </li>
            </ul>
            <div>
              <ReactApexChart
                options={donutChartOptionsTwo}
                series={trimmedSupport}
                type="donut"
                height={300}
                id="donutChart"
                className="flex-grow-1 apexcharts-tooltip-z-none title-style circle-none"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportTracket;
